import React from 'react';
import Icon from '../../../components/AppIcon';

const AnalyticsStats = ({ teamKPIs, agentMetrics }) => {
  const avgResponseTime = agentMetrics?.length > 0
    ? Math.round(agentMetrics?.reduce((sum, agent) => sum + agent?.avgResponseTime, 0) / agentMetrics?.length)
    : 0;

  const avgCompletionRate = agentMetrics?.length > 0
    ? Math.round((agentMetrics?.reduce((sum, agent) => sum + agent?.completionRate, 0) / agentMetrics?.length) * 10) / 10
    : 0;

  const avgAccuracyScore = agentMetrics?.length > 0
    ? Math.round((agentMetrics?.reduce((sum, agent) => sum + agent?.accuracyScore, 0) / agentMetrics?.length) * 10) / 10
    : 0;

  const avgSuccessRate = agentMetrics?.length > 0
    ? Math.round((agentMetrics?.reduce((sum, agent) => sum + agent?.successRate, 0) / agentMetrics?.length) * 10) / 10
    : 0;

  const statCards = [
    {
      id: 'active-agents',
      label: 'Active Agents',
      value: teamKPIs?.activeAgents || 0,
      icon: 'Users',
      color: 'var(--color-primary)',
      bgColor: 'var(--color-primary)15'
    },
    {
      id: 'avg-response-time',
      label: 'Avg Response Time',
      value: `${avgResponseTime}s`,
      icon: 'Clock',
      color: 'var(--color-accent)',
      bgColor: 'var(--color-accent)15'
    },
    {
      id: 'completion-rate',
      label: 'Avg Completion Rate',
      value: `${avgCompletionRate}%`,
      icon: 'CheckCircle',
      color: 'var(--color-success)',
      bgColor: 'var(--color-success)15'
    },
    {
      id: 'accuracy-score',
      label: 'Avg Accuracy Score',
      value: `${avgAccuracyScore}%`,
      icon: 'Target',
      color: 'var(--color-warning)',
      bgColor: 'var(--color-warning)15'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {statCards?.map((stat) => (
        <div key={stat?.id} className="card">
          <div className="flex items-center justify-between">
            <div className="flex-1 min-w-0">
              <p className="text-sm text-muted-foreground caption mb-1">{stat?.label}</p>
              <p className="text-2xl md:text-3xl font-semibold data-text text-foreground">
                {stat?.value}
              </p>
            </div>
            <div
              className="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-lg flex-shrink-0"
              style={{ backgroundColor: stat?.bgColor }}
            >
              <Icon name={stat?.icon} size={24} color={stat?.color} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnalyticsStats;